import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 24px 0 4px;
`

export const Information = styled.div`
  > div {
    padding-top: 0px;
  }
  div > div + div {
    padding: 8px 0 0;
  }
  div > div + div + div {
    padding: 4px 0 0;
  }
`

export const Content = styled.div<{ approved: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 24px;
  > div {
    flex: 1 1 20%;
    border: 1px solid ${(props) => (props.approved ? '#88E3BC' : '#F7A2A2')};
    background: ${(props) => (props.approved ? '#D7F5E97A' : '#FDE0E07A')};
    padding: 16px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    position: relative;
    svg {
      background: ${(props) => (props.approved ? '#AFECD3' : '#FAC1C1')};
      padding: 4px;
      border-radius: 4px;
      font-size: 16px;
    }
    span {
      font-weight: 700;
      font-size: 16px;
      position: absolute;
      margin-left: 8px;
    }
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    @media (max-width: 768px) {
      flex: 1 1 100%;
    }
  }
`
